var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', [_c('div', {
    class: "imgs-slide imgs-slide-".concat(_vm.random)
  }, [_c('div', {
    staticClass: "swiper-container"
  }, [_c('div', {
    staticClass: "swiper-wrapper"
  }, _vm._l(_vm.srcs, function (src) {
    return _c('div', {
      key: src,
      staticClass: "swiper-slide"
    }, [_c('v-card', {
      staticClass: "imgs-slide__img",
      attrs: {
        "flat": "",
        "rounded": "lg",
        "target": "_blank",
        "href": src
      }
    }, [_c('v-img', _vm._b({
      attrs: {
        "aspect-ratio": 368 / 217,
        "width": "100%"
      }
    }, 'v-img', {
      src: src
    }, false))], 1)], 1);
  }), 0)])])]);
}
var staticRenderFns = []

export { render, staticRenderFns }